import React from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import '../App.css'
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import News1 from '../img/news1.png';
import News2 from '../img/news2.png';
import News3 from '../img/news3.png';
import News4 from '../img/news4.png';
import News5 from '../img/news5.png';
import News6 from '../img/news6.png';

export default function App() {
  return (
    <>
      <Swiper
        slidesPerView={3}
        spaceBetween={20}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 3200,
          disableOnInteraction: false,
        }}
        breakpoints={{
          300: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          400: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
      >

        <SwiperSlide>
            <div className='flex justify-center'>
                <img src={News1} alt="News 1" className='w-28'/>
            </div>
            <h3 className='text-emerald-900 mt-3 text-lg text-center font-bold '>Combatting Malaria</h3>
            <p className='text-slate-800 mt-7 text-justify text-sm leading-7'>Kenya’s government has made significant progress in fighting malaria.</p>
            <button className='bg-emerald-800 rounded-full px-12 py-3 mt-5 whitespace-nowrap text-white'>learn more</button>
        </SwiperSlide>
        <SwiperSlide id='orange'>
            <div className='flex justify-center'>
                <img src={News2} alt="News 2" className='w-28'/>
            </div>
            <h3 className='text-white text-lg mt-3 text-center font-bold'>Immunization</h3>
            <p className='text-white mt-7 text-justify text-sm leading-7 text-slate-600'>The Kenyan Health CS has prioritized the unvaccinated in the country.</p>
            <button className='bg-white rounded-full px-12 py-3 mt-5 whitespace-nowrap text-orange-700'>learn more</button>
        </SwiperSlide>
        <SwiperSlide>
            <div className='flex justify-center'>
                <img src={News3} alt="News 3" className='w-28'/>
            </div>
            <h3 className='text-emerald-900 mt-3 text-lg text-center font-bold '>Infant Mortality</h3>
            <p className='text-slate-800 mt-7 text-justify text-sm leading-7'>There has been a steady decline in infant mortality since 2021. </p>
            <button className='bg-emerald-800 rounded-full px-12 py-3 mt-5 whitespace-nowrap text-white'>learn more</button>
        </SwiperSlide>
        <SwiperSlide>
            <div className='flex justify-center'>
                <img src={News4} alt="News 4"/>
            </div>
            <h3 className='text-emerald-900 mt-3 text-lg text-center font-bold '>KNH Management</h3>
            <p className='text-slate-800 mt-7 text-justify text-sm leading-7'>The Kenya Health CS inaugrated a new board to manage KNH.</p>
            <button className='bg-emerald-800 rounded-full px-12 py-3 mt-5 whitespace-nowrap text-white'>learn more</button>
        </SwiperSlide>
        <SwiperSlide id='orange'>
            <div className='flex justify-center'>
                <img src={News5} alt="News 2" className='w-2/3'/>
            </div>
            <h3 className='text-white mt-3 text-lg text-center font-bold'>Vaccine Transport</h3>
            <p className='text-white mt-7 text-justify text-sm leading-7'>MOH handed over a refrigerated Land Cruiser vehicle to Samburu.</p>
            <button className='bg-white rounded-full px-12 py-3 mt-5 whitespace-nowrap text-orange-700'>learn more</button>
        </SwiperSlide>
        <SwiperSlide>
            <div className='flex justify-center'>
                <img src={News6} alt="News 4" className='w-36'/>
            </div>
            <h3 className='text-emerald-900 mt-3 text-lg text-center font-bold '>Bio Laboratory</h3>
            <p className='text-slate-800 mt-7 text-justify text-sm leading-7'>MOH held a meeting with representatives of Amref, and USAID.</p>
            <button className='bg-emerald-800 rounded-full px-12 py-3 mt-5 whitespace-nowrap text-white'>learn more</button>
        </SwiperSlide>




      </Swiper>
    </>
  );
}